import { useMediaQuery } from "@mui/material";

export const DocStyleContent = ({
  children,
  maxContentWidth = 1000,
  headerSpacing = 6,
  sectionSpacing = 6,
  className,
  ...props
}) => {
  const isSmallScreen = useMediaQuery("@media (max-width:599px)");
  const isMediumScreen = useMediaQuery("@media (max-width:959px)");

  // Convert spacing units (MUI spacing = 8px, so spacing(6) = 48px)
  const headerSpacingPx = headerSpacing * 8;
  const sectionSpacingPx = sectionSpacing * 8;
  const paddingPx = isSmallScreen ? 32 : isMediumScreen ? 48 : 0;

  return (
    <>
      <style>{`
        .doc-style-content {
          max-width: ${maxContentWidth}px;
          margin: 0 auto;
          padding: ${paddingPx}px;
        }
        .doc-style-content h1 {
          text-align: center;
          font-size: ${
            isSmallScreen ? "1.75rem" : isMediumScreen ? "2rem" : "2.5rem"
          };
          font-weight: 700;
          margin-top: ${isSmallScreen ? 32 : isMediumScreen ? 48 : 64}px;
          margin-bottom: ${headerSpacingPx}px;
          color: hsl(var(--foreground));
          letter-spacing: 0.5px;
        }
        .doc-style-content h2 {
          font-size: ${isMediumScreen ? "1.25rem" : "1.5rem"};
          font-weight: 600;
          margin-top: ${sectionSpacingPx}px;
          color: hsl(var(--foreground));
          padding-bottom: ${8}px;
          border-bottom: 1px solid hsl(var(--background));
        }
        .doc-style-content p {
          font-size: ${isMediumScreen ? "0.95rem" : "1rem"};
          line-height: 1.8;
          color: hsl(var(--foreground));
          text-align: justify;
        }
        .doc-style-content p:first-of-type {
          font-size: ${isMediumScreen ? "1rem" : "1.1rem"};
          color: hsl(var(--muted-foreground));
        }
        .doc-style-content ul,
        .doc-style-content ol {
          padding-left: ${32}px;
        }
        .doc-style-content li {
          color: hsl(var(--foreground));
          line-height: 1.7;
          position: relative;
        }
        .doc-style-content li::marker {
          color: hsl(var(--muted-foreground));
        }
      `}</style>
      <div className={`doc-style-content ${className || ""}`} {...props}>
        {children}
      </div>
    </>
  );
};

export default DocStyleContent;
